/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

//Backend access
import { useQuery } from '@tanstack/react-query';
import { loadToken, getLiveviewHistory } from 'services/api/bks';
import PropTypes from "prop-types";

import ClearwayOverlay from '../../../assets/images/clearway_overlay.png';
import NoPreviewImg from '../../../assets/images/not_available.png';

import { useAuth0 } from "@auth0/auth0-react";
import breakpoints from "assets/theme/base/breakpoints";
import moment from "moment";

function GroupLiveViewHistory({ group, event, selectedOrg, has_started }) {
  loadToken(useAuth0());

  var uuids = [];
  for (var index in group.devices) {
    uuids.push(group.devices[index].uuid);
  }

  if (has_started) {
    var { isLoading, error, data, isFetching } = useQuery({
      queryKey: ['getLiveviewHistory', uuids, selectedOrg, moment(event.start_time).unix(), moment(event.end_time).unix()],
      queryFn: async () => {
        const data = await getLiveviewHistory(uuids, moment(event.start_time).unix(), moment(event.end_time).unix());
        return data;
      }
    });
  }
  else {
    var { isLoading, error, data, isFetching } = useQuery({
      queryKey: ['getLiveviewHistory', uuids, selectedOrg, moment(event.display_time).unix(), moment(event.end_time).unix()],
      queryFn: async () => {
        const data = await getLiveviewHistory(uuids, moment(event.display_time).unix(), moment(event.end_time).unix());
        return data;
      }
    });
  }

  if (isLoading) { return ("Loading..."); }
  if (error) { return ("Error! " + error.message); }

  // console.log(data);

  // var processed_liveviews = processLiveViewHistoryData(data.updates, event);

  var bucket_paths = {};

  for (var update of data.updates) {
    if (typeof bucket_paths[update.bucket_path] == 'undefined') {
      bucket_paths[update.bucket_path] = 0;
    }
    bucket_paths[update.bucket_path]++;
  }

  var chosen_path = { path: '', count: 0 };
  for (var path in bucket_paths) {
    if (!path.includes("a59dbb016c69d8237bb072227632ed29") && bucket_paths[path] > chosen_path.count) {
      chosen_path = { path: path, count: bucket_paths[path] };
    }
  }

  try {
    var chosen_image = data.images[chosen_path.path].signed_url;
  }
  catch (e){
    // signed_url not found, use preview not available

    var chosen_image = NoPreviewImg;
  }

  // const blob = new Blob([data.images[data.updates[0].bucket_path].signed_url]);
  // const url = URL.createObjectURL(blob);

  var liveview_max_width = '1250px';
  if (window.innerWidth < breakpoints.values.lg) {
    liveview_max_width = '475px';
  }
  else if (window.innerWidth < breakpoints.values.xl) {
    liveview_max_width = '540px';
  }
  else if (window.innerWidth < breakpoints.values.xxl) {
    liveview_max_width = '600px';
  }
  else if (window.innerWidth < breakpoints.values.x3l) {
    liveview_max_width = '700px';
  }

  return (
    <SoftBox width="100%" height="100%" sx={{ marginLeft: '16px', marginRight: '16px', marginTop: '16px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start' }}>
      <SoftBox width={'100%'} height={'100%'}>
        <SoftBox width="100%"  >
          <SoftBox width="100%" height="100%" position="relative" borderRadius="lg">
            <SoftBox
              component="img"
              src={chosen_image}
              position="absolute"
              width="60%"
              borderRadius="lg"
              sx={{ marginLeft: "36%", marginTop: "4.5%" }}
              zIndex="1"
            />
            <SoftBox
              component="img"
              src={ClearwayOverlay}
              // position="absolute"
              // top={0}
              // left={0}
              position="relative"
              height="100%"
              width="100%"
              borderRadius="lg"
              zIndex="2"
            />
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the GroupLiveViewHistory
GroupLiveViewHistory.propTypes = {
  group: PropTypes.object,
  event: PropTypes.object,
  selectedOrg: PropTypes.string,
  has_started: PropTypes.bool,
};


export default GroupLiveViewHistory;
